<template lang="pug">
  div
    div(ref='luls',style='position:absolute; left:0px; top:0px')
      div(ref='targets')
        slot(name='default')
    //div(ref='moveTargetRef',:style='style2')
      slot

</template>
<script>
import { debounce } from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import Moveable from 'moveable';

const ALLOWED_EVENTS = [
  'dragStart',
  'drag',
  'dragEnd',
  'resizeStart',
  'resize',
  'resizeEnd',
  'scaleStart',
  'scale',
  'scaleEnd',
  'rotateStart',
  'rotate',
  'rotateEnd',
  'warpStart',
  'warp',
  'warpEnd',
  'pinchStart',
  'pinch',
  'pinchEnd',
];

export default {
  name: 'Moveable',
  inheritAttrs: false,
  props: {
    bounds: Object,
    moveableTargets: Array,
    draggable: Boolean,
    resizable: Boolean,
    scalable: Boolean,
    rotatable: Boolean,
    warpable: Boolean,
    pinchable: [Boolean, Array],
    origin: Boolean,
    throttleDrag: Number,
    throttleResize: Number,
    throttleScale: Number,
    throttleRotate: Number,
    keepRatio: Boolean,
    container: Object,
  },
  methods: {
    draggedEnoughDistance(clientX, clientY) {
      const prevX = this.__dragStartX || 0;
      const prevY = this.__dragStartY || 0;
      const dx = (clientX - prevX)*(clientX - prevX);
      const dy = (clientY - prevY)*(clientY - prevY);
      return Math.abs(dx + dy) > 30;
    },
    updateRect() {
      this.moveable.updateRect();
    },
    _updateTargets() {
      if (this.destroyed) {
        return true;
      }
      if (this.moveable) {
        this.moveable.updateTarget();
        this.moveable.updateRect();
      }
    },
    _updateMoveable(in_opts) {
      if (this.destroyed) {
        return;
      }
      if (this.moveable) {
        this.currentOpts = this.createOpts(in_opts);
        const targets = this.getMoveableTargets();
        //if (targets.length === 0) {
          //this.currentOpts = this.createInitialOpts();
        //}
        let opts = this.currentOpts;
        opts.target = targets;
        this.moveable.setState(opts);
        this.moveable.updateTarget();
        this.moveable.updateRect();
        this._updateTargets();
      } else {
        this.createOpts(in_opts);
        this.createMoveable();
      }
    },
    createOpts(in_opts) {
      this.currentOpts = Object.assign({},this.currentOpts,in_opts);
      return this.currentOpts;
    },
    createInitialOpts() {
      const target = this.$refs.luls;
      return {
        container:target,
        draggable: true,
        scalable: true,
        rotatable: true,
        //warpable: true,

        // Enabling pincable lets you use events that
        // can be used in draggable, resizable, scalable, and rotateable.
        //pinchable: true, // ["resizable", "scalable", "rotatable"]
        origin: true,
        keepRatio: this.keepRatio,
        throttleDrag: 0,
        throttleResize: 0,
        throttleScale: 0,
        throttleRotate: 0,
      };
    },
    getMoveableTargets() {
      if (this.$refs && this.$refs.targets) {
        const targets = [].slice.call(this.$refs.targets.querySelectorAll('.drag-target'));
        return targets;
      } else {
        return [];
      }
    },
    _createMoveable() {
      if (this.destroyed) {
        return;
      }
      const target = this.$refs.luls;
      const targets = this.getMoveableTargets();

      const moveableOpts = this.createOpts();
      moveableOpts.target = targets;

      this.moveable = new Moveable(target, moveableOpts);

      this.moveable.on('dragStart', ({target, clientX, clientY}) => {
        this.__dragStartX = clientX;
        this.__dragStartY = clientY;
        const transformKey = target.dataset.transformKey;
        if (!transformKey) {
          console.error('no id found', target);
          return;
        }
        this.handleOnDragStart([transformKey], {
          clientX, clientY
        })
      });
      this.moveable.on("dragGroupStart", ({ targets, clientX, clientY }) => {
        this.__dragStartX = clientX;
        this.__dragStartY = clientY;

        const keys = new Set(targets.map( (t) => {
          return t.dataset.transformKey;
        }));

        this.handleOnDragStart([...keys], {
            clientX, clientY
        });

      })

      //this.moveable.updateTarget();

      this.moveable.on('drag', ({ target, beforeDelta, beforeTranslate, clientX, clientY }) => {
        //if (!this.draggedEnoughDistance(clientX, clientY)) {
          //console.log('not dragged far enough');
          //return;
        //}

        const transformKey = target.dataset.transformKey;
        if (!transformKey) {
          console.error('no id found', target);
          return;
        }
        this.handleEvent(transformKey, 'onDrag', {
          beforeDelta
        });
      });
      this.moveable.on("dragGroup", ({ events, clientX, clientY }) => {
        //if (!this.draggedEnoughDistance(clientX, clientY)) {
          //console.log('not dragged far enough');
          //return;
        //}
        const ids = new Set();
        events.forEach( ({target, beforeDelta, beforeTranslate}) => {
          const transformKey = target.dataset.transformKey;
          if (ids.has(transformKey)) {
            return;
          }
          ids.add(transformKey);
          this.handleEvent(transformKey, 'onDrag', {
            beforeDelta
          });
        });
      })

      //this.moveable.on('dragEnd', ({target, clientX, clientY}) => {
      this.moveable.on('dragEnd', ({isDrag, target, clientX, clientY}) => {
        const transformKey = target.dataset.transformKey;
        if (!this.draggedEnoughDistance(clientX, clientY)) {
          isDrag = false;
          // move it back?
          this.handleEvent([transformKey], 'onDrag', {
            beforeDelta: [this.__dragStartX - clientX, this.__dragStartY - clientY],
          });
          //return;
        }
        this.handleEvent(transformKey, 'onDragEnd', { });
        this.handleOnDragEnd([transformKey], {
            clientX, clientY, isDrag
        });
      });
      this.moveable.on("dragGroupEnd", ({ targets, left, top, right, bottom, target, isDrag, clientX, clientY }) => {
        const ids = new Set(targets.map( (t) => {
          return t.dataset.transformKey;
        }));

        if (!this.draggedEnoughDistance(clientX, clientY)) {
          isDrag = false;
          // move it back?
          this.handleEvent([...ids], 'onDrag', {
            beforeDelta: [this.__dragStartX - clientX, this.__dragStartY - clientY],
          });
          //return;
        }
        this.handleOnDragEnd([...ids], {
          clientX,
          clientY,
          isDrag
        });
      });

      this.moveable.on('rotateStart', ({target}) => {
        const transformKey = target.dataset.transformKey;
        this.totalRotationDelta = 0;
        this.handleOnRotateStart([transformKey], {
        });
      });
      this.moveable.on('rotateGroupStart', ({targets}) => {
        const keys = new Set(targets.map( (t) => {
          return t.dataset.transformKey;
        }));

        this.handleOnRotateStart([...keys], {
        });
      });
      this.moveable.on('rotateGroupEnd', ({targets}) => {
        const keys = new Set(targets.map( (t) => {
          return t.dataset.transformKey;
        }));

        this.handleOnRotateEnd([...keys], {
            totalRotationDelta: this.totalRotationDelta
        });
      });
      this.moveable.on("rotate", ({ target, beforeDelta, delta}) => {
        const transformKey = target.dataset.transformKey;
        if (!transformKey) {
          console.error('no id found', target);
          return;
        }
        this.totalRotationDelta += delta;
        this.handleEvent(transformKey, 'onRotate', {
          beforeDelta,
          delta
        });
      });
      this.moveable.on('rotateGroup', ({events}) => {
        const ids = new Set();
        events.forEach( ({target, beforeDelta, delta }) => {
          const transformKey = target.dataset.transformKey;
          if (ids.has(transformKey)) {
            return;
          }
          ids.add(transformKey);
          this.handleEvent(transformKey, 'onRotate', {
            beforeDelta,
            delta
          });
        });
      });
      this.moveable.on('rotateEnd', ({target}) => {
        const transformKey = target.dataset.transformKey;
        this.handleOnRotateEnd([transformKey], {
          totalRotationDelta: this.totalRotationDelta
        });
      });


      this.moveable.on('scaleStart', ({target, delta, ...rest}) => {
        const transformKey = target.dataset.transformKey;
        this.handleOnScaleStart([transformKey], {
        });
      });
      this.moveable.on("scale", ({ target, delta, scale, ...rest}) => {
        const transformKey = target.dataset.transformKey;
        if (!transformKey) {
          console.error('no id found', target);
          return;
        }
        this.handleEvent(transformKey, 'onScale', {
          delta,
          scale
        });
      });
      this.moveable.on('scaleEnd', ({target}) => {
        const transformKey = target.dataset.transformKey;
        this.handleOnScaleEnd([transformKey], {
        });
      });

      this.moveable.on('scaleGroupStart', ({targets}) => {
        const keys = new Set(targets.map( (t) => {
          return t.dataset.transformKey;
        }));

        this.handleOnScaleStart([...keys], {
        });
      });
      this.moveable.on('scaleGroup', ({delta, scale, events}) => {
        const ids = new Set();
        events.forEach( ({target, beforeDelta, delta }) => {
          const transformKey = target.dataset.transformKey;
          if (ids.has(transformKey)) {
            return;
          }
          ids.add(transformKey);
          this.handleEvent(transformKey, 'onScale', {
            delta,
            scale
          });
        });
      });

      this.moveable.on('scaleGroupEnd', ({targets}) => {
        const keys = new Set(targets.map( (t) => {
          return t.dataset.transformKey;
        }));

        this.handleOnScaleEnd([...keys], {
        });
      });

    },
    registerDrag(id, handlers) {
      this.handlers[id] = handlers;
      this.updateMoveable();
    },
    deregisterDrag(id) {
      delete this.handlers[id];
      this.updateMoveable();
    },

    addTarget(t) {
      this.updateMoveable();
    },
    removeTarget(t) {
      this.updateMoveable();
    },

    updateRec() {
      if (this.destroyed) {
        return
      }
      this.moveable.updateRect();
    },
    handleEvent(id, eventName, payload) {
      if (this.handlers[id]) {
        this.$emit(eventName, {id,payload});
        return this.handlers[id][eventName](payload);
      } else {
        console.error('[handleEvent]', id, 'handler for', eventName, 'not present');
      }
    },
    handleOnDragStart(keys, {clientX, clientY}) {
      const data = [];
      for (let i = 0; i < keys.length; i++) {
        const transformKey = keys[i];
        const d = this.handleEvent(transformKey, 'onDragStart', {
          clientX, clientY
        });
        data.push(d);
      }
      this.$emit("drag-start", {data});
    },
    handleOnDragEnd(keys, {clientX, clientY,isDrag}) {
      const data = [];
      if (isDrag) {
        for (let i = 0; i < keys.length; i++) {
          const transformKey = keys[i];
          const d = this.handleEvent(transformKey, 'onDragEnd', {
            clientX, clientY
          });
          data.push(d);
        }
        this.$emit("drag-end", {data});
      } else {
        this.$emit("drag-end", {data});
        this.$emit("tap", {clientX,clientY,data});
      }

    },
    handleOnRotateStart(keys, {}) {
      const data = [];
      for (let i = 0; i < keys.length; i++) {
        const transformKey = keys[i];
        const d = this.handleEvent(transformKey, 'onRotateStart', {
        });
        data.push(d);
      }
      this.$emit("rotate-start", {data});
    },
    handleOnRotateEnd(keys, {}) {
      const data = [];
      for (let i = 0; i < keys.length; i++) {
        const transformKey = keys[i];
        const d = this.handleEvent(transformKey, 'onRotateEnd', {
        });
        data.push(d);
      }
      this.$emit("rotate-end", {
        totalRotationDelta: this.totalRotationDelta,
        data
      });

      this.totalRotationDelta = 0;

    },
    handleOnScaleStart(keys, {}) {
      const data = [];
      for (let i = 0; i < keys.length; i++) {
        const transformKey = keys[i];
        const d = this.handleEvent(transformKey, 'onScaleStart', {
        });
        data.push(d);
      }
      this.$emit("scale-start", {data});
    },
    handleOnScaleEnd(keys, {}) {
      const data = [];
      for (let i = 0; i < keys.length; i++) {
        const transformKey = keys[i];
        const d = this.handleEvent(transformKey, 'onScaleEnd', {
        });
        data.push(d);
      }
      this.$emit("scale-end", {data});
    },


  },
  data() {
    return {
      startDragPoint:{x:0,y:0},
      handlers:{},
      initialOpts:this.createInitialOpts(),
      currentOpts:Object.assign({},this.createInitialOpts())
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateRec, { passive: true });
    this.createMoveable = debounce(this._createMoveable.bind(this), 200);
    this.createMoveable();
    this.updateTargets = debounce(this._updateTargets.bind(this), 100);
    this.updateMoveable = debounce(this._updateMoveable.bind(this), 20);
  },
  computed:{
  },
  beforeDestroy() {
    this.destroyed = true;
    window.removeEventListener('resize', this.updateRec);
    if (!this.moveable) {
      return;
    }
    ALLOWED_EVENTS.forEach(event => (
      this.moveable.off(event, this.$emit.bind(this, event))
    ));
    this.moveable.destroy();
    this.moveable = null;
  },
  watch:{
    keepRatio(nv) {
      this._updateMoveable({
        keepRatio:nv
      });
    }
  }
};
</script>
<style>

</style>
